<div class="login-container">
<!-- <div class="go-to-login">
    Already registered?
    <a href="/login">Go to Login</a>
  </div> -->
  <h2 class="page-title">Supplier Evaluation Questionnaire</h2>
   
  <div class="form-wrapper">
<div class="registration-container">

  <form [formGroup]="evaluationForm"
        (ngSubmit)="submitEvaluation()">

    <!-- Company Information -->

    <h2 class="section-title">
      Company Information
    </h2>

    <div class="form-section grid-3">

      <mat-form-field appearance="outline">
        <mat-label>Location of Head Office</mat-label>
        <textarea matInput
                  rows="2"
                  formControlName="headOfficeLocation" maxlength="500">
        </textarea>
      </mat-form-field>

      <!-- <mat-form-field appearance="outline">
        <mat-label>Website</mat-label>
        <input matInput
               formControlName="website">
      </mat-form-field> -->
      <mat-form-field appearance="outline">
  <mat-label>Website</mat-label>

  <input matInput formControlName="website" maxlength="255">

  <mat-error *ngIf="evaluationForm.get('website')?.hasError('pattern')">
    Please enter a valid website URL.
  </mat-error>
</mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>No. of Branches & Their Location</mat-label>
        <textarea matInput
                  rows="2"
                  formControlName="branchesInfo" maxlength="2000">
        </textarea>
      </mat-form-field>

    </div>

    <!-- Management -->

    <h2 class="section-title">
      Management System Certification
    </h2>

    <mat-checkbox formControlName="managementCertified">
      Is your management system certified?
    </mat-checkbox>

    <div class="checkbox-content"
         *ngIf="evaluationForm.get('managementCertified')?.value">

      <div class="form-section">

        <mat-form-field appearance="outline">

          <mat-label>Management Standards</mat-label>

          <input matInput
                 formControlName="managementStandards" maxlength="2000">

        </mat-form-field>

        <div class="file-upload">

          <label>Management Certificate</label>

          <div class="upload-wrapper">

            <button mat-raised-button
                    color="primary"
                    type="button"
                    (click)="managementFile.click()">

              Upload File

            </button>

            <span class="file-name">
              {{managementCertFileName || 'No file selected'}}
            </span>

            <input hidden
                   #managementFile
                   type="file"
                   (change)="onFileChange($event,'ManagementCert')">

          </div>

        </div>

      </div>

    </div>

    <!-- Appreciation Letters -->

    <h2 class="section-title">
      Appreciation Letters
    </h2>

    <div class="file-upload">

      <div class="upload-wrapper">

        <button mat-raised-button
                color="primary"
                type="button"
                (click)="appreciationFile.click()">

          Upload File

        </button>

        <span class="file-name">
          {{appreciationLettersFileName || 'No file selected'}}
        </span>

        <input hidden
               #appreciationFile
               type="file"
               (change)="onFileChange($event,'AppreciationLetters')">

      </div>

    </div>

    <!-- Zakat -->

    <h2 class="section-title">
      Valid Zakat Certificate
    </h2>

    <div class="file-upload">

      <div class="upload-wrapper">

        <button mat-raised-button
                color="primary"
                type="button"
                (click)="zakatFile.click()">

          Upload File

        </button>

        <span class="file-name">
          {{zakatCertificateFileName || 'No file selected'}}
        </span>

        <input hidden
               #zakatFile
               type="file"
               (change)="onFileChange($event,'ZakatCertificate')">

      </div>

    </div>

    <!-- Major Customers -->

    <h2 class="section-title">
      Major Customers
    </h2>

    <mat-form-field appearance="outline"
                    class="full-width">

      <mat-label>Major Customers</mat-label>

      <textarea matInput
                rows="4"
                formControlName="majorCustomers" maxlength="2000">
      </textarea>

    </mat-form-field>

    <div class="file-upload">

      <div class="upload-wrapper">

        <button mat-raised-button
                color="primary"
                type="button"
                (click)="customerFile.click()">

          Upload File

        </button>

        <span class="file-name">
          {{majorCustomersFileName || 'No file selected'}}
        </span>

        <input hidden
               #customerFile
               type="file"
               (change)="onFileChange($event,'MajorCustomersFile')">

      </div>

    </div>

    <!-- Material Certificates -->

    <h2 class="section-title">
      Material Certificates
    </h2>

    <mat-checkbox formControlName="materialCertificates">

      Can furnish MTC / Batch Certificates /
      Warranty Certificates

    </mat-checkbox>

    <div class="checkbox-content"
         *ngIf="evaluationForm.get('materialCertificates')?.value">

      <mat-form-field appearance="outline"
                      class="full-width">

        <mat-label>Certificate Details</mat-label>

        <textarea matInput
                  rows="3"
                  formControlName="materialCertificatesNotes" maxlength="2000">
        </textarea>

      </mat-form-field>

    </div>

    <!-- After Sales Support -->

    <h2 class="section-title">
      After Sales Support
    </h2>

    <mat-form-field appearance="outline"
                    class="full-width">

      <mat-label>After Sales Support Details</mat-label>

      <textarea matInput
                rows="4"
                formControlName="afterSalesSupport" maxlength="2000">
      </textarea>

    </mat-form-field>

    <!-- Enclosures -->

    <h2 class="section-title">
      List Of Enclosures
    </h2>

    <mat-form-field appearance="outline"
                    class="full-width">

      <mat-label>List Of Enclosures</mat-label>

      <textarea matInput
                rows="4"
                formControlName="listOfEnclosures" maxlength="2000">
      </textarea>

    </mat-form-field>

    <div class="form-actions">

      <button mat-raised-button
              type="submit"
              class="submit-vendor-btn">

        <span *ngIf="!isLoading">
          Submit Evaluation
        </span>

        <span *ngIf="isLoading"
              class="loader">
        </span>

      </button>

    </div>

  </form>

</div>

   
  </div>
</div>